import fetchAPI from '../fetchAPI';
import { useQuery } from '@tanstack/react-query';

type LeadEventsProps = {
  startDate?: string | null;
  endDate?: string | null;
  locationId?: string;
  type: string;
};

export const useLeadEvents = ({ locationId, endDate, startDate, type }: LeadEventsProps) => {
  const query = new URLSearchParams();

  if (locationId) query.append('locationId', locationId);
  if (endDate) query.append('endDate', endDate);
  if (startDate) query.append('startDate', startDate);
  return useQuery({
    queryKey: ['lead-event', type, startDate, endDate, locationId],
    queryFn: async () => {
      const response: iResponse<{
        total: number;
        qualified: Record<string, number>;
        valuation: Record<string, number>;
        mortgage: Record<string, number>;
      }> = await fetchAPI({
        method: 'GET',
        route: `lead-event/${type}`,
        queryString: query.toString()
      });

      return response;
    },
    enabled: !!startDate && !!endDate
  });
};

export default useLeadEvents;
